import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Form } from 'semantic-ui-react';
import { getAddressText, timeToMinutes, shouldShowFulfillmentPickers, isFulfillmentTypeAvailable } from './FulfillmentInformationForm.utils';
import FulfillmentTypePicker from '../../modules/fulfillment/components/FulfillmentTypePicker';
import { FULFILLMENT_TYPE_IN_STORE, FULFILLMENT_TYPE_DELIVERY, FULFILLMENT_TYPE_SHIPPING, FULFILLMENT_TYPE_TO_TEXT, FULFILLMENT_PROVIDER_MERCHANT, FULFILLMENT_PROVIDER_SHIPPO } from '../../modules/fulfillment/constants';
import { getDefaultFulfillmentTypeForOrder, getFulfillmentDefaultRateAmount, getFulfillmentDefaultRateDuration } from '../../modules/fulfillment/services';
import { OrderPropType } from '../../services/proptypes';
import DynamicAddressForm from '../DynamicAddressForm';
import './FulfillmentInformationForm.css';
var defaultProps = {
  firstName: '',
  lastName: '',
  country: '',
  state: '',
  city: '',
  postalCode: '',
  line1: '',
  line2: '',
  fulfillmentMethod: {},
  defaultEnterManualAddress: false,
  showCountryInput: true
};
function FulfillmentInformationForm(_ref) {
  var _order$fulfillment, _order$fulfillment$me;
  var order = _ref.order,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    country = _ref.country,
    state = _ref.state,
    city = _ref.city,
    postalCode = _ref.postalCode,
    line1 = _ref.line1,
    line2 = _ref.line2,
    fulfillmentMethod = _ref.fulfillmentMethod,
    onChange = _ref.onChange,
    defaultEnterManualAddress = _ref.defaultEnterManualAddress,
    showCountryInput = _ref.showCountryInput;
  var fulfillmentType = fulfillmentMethod.fulfillmentType;
  var _useState = useState(fulfillmentType || getDefaultFulfillmentTypeForOrder(order)),
    _useState2 = _slicedToArray(_useState, 2),
    currentFulfillmentType = _useState2[0],
    setCurrentFulfillmentType = _useState2[1];
  useEffect(function () {
    setCurrentFulfillmentType(fulfillmentType);
  }, [fulfillmentType]);
  var currentOrderFulfillmentType = order === null || order === void 0 ? void 0 : (_order$fulfillment = order.fulfillment) === null || _order$fulfillment === void 0 ? void 0 : (_order$fulfillment$me = _order$fulfillment.method) === null || _order$fulfillment$me === void 0 ? void 0 : _order$fulfillment$me.type;
  function onFieldChange(e, _ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    onChange(_defineProperty({}, name, value));
  }
  function pickUpTimeComponent() {
    var minutesStr = timeToMinutes(order.order_turnaround_time);
    if (minutesStr) {
      return /*#__PURE__*/React.createElement("p", null, "Ready in ", minutesStr, " mins.");
    }
    return null;
  }
  function getAddressFormLabel() {
    if (currentFulfillmentType === FULFILLMENT_TYPE_DELIVERY) {
      return 'Delivers To';
    }
    if (currentFulfillmentType === FULFILLMENT_TYPE_SHIPPING) {
      return 'Ships To';
    }
    return 'Address';
  }
  var addressText = getAddressText(order.location_address);
  var addressComponent = order.location_address.url ? /*#__PURE__*/React.createElement("a", {
    href: order.location_address.url
  }, addressText) : addressText;
  return /*#__PURE__*/React.createElement("div", {
    className: "fulfillment-information-form"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    widths: "equal"
  }, /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    name: "firstName",
    label: "First Name",
    value: firstName,
    onChange: onFieldChange,
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    fluid: true,
    name: "lastName",
    label: "Last Name",
    value: lastName,
    onChange: onFieldChange,
    required: true
  })), /*#__PURE__*/React.createElement(DynamicAddressForm, {
    merchant: {
      productId: order.merchant_product,
      locationId: order.merchant_location
    },
    fulfillmentMethod: fulfillmentMethod,
    onChange: onChange,
    country: country,
    state: state,
    city: city,
    postalCode: postalCode,
    line1: line1,
    line2: line2,
    defaultEnterManualAddress: defaultEnterManualAddress,
    showCountryInput: showCountryInput,
    label: getAddressFormLabel()
  }), shouldShowFulfillmentPickers(order) && /*#__PURE__*/React.createElement(Form.Group, {
    className: "fulfillment-type-picker-group"
  }, isFulfillmentTypeAvailable(order, FULFILLMENT_TYPE_IN_STORE) && /*#__PURE__*/React.createElement(FulfillmentTypePicker, {
    type: FULFILLMENT_TYPE_IN_STORE,
    isSelected: currentFulfillmentType === FULFILLMENT_TYPE_IN_STORE,
    onSelect: function onSelect(value) {
      return onChange({
        fulfillmentType: value
      });
    }
  }, /*#__PURE__*/React.createElement("p", null, "At ", addressComponent), pickUpTimeComponent()), isFulfillmentTypeAvailable(order, FULFILLMENT_TYPE_SHIPPING) && /*#__PURE__*/React.createElement(FulfillmentTypePicker, {
    type: FULFILLMENT_TYPE_SHIPPING,
    title: currentOrderFulfillmentType === FULFILLMENT_TYPE_SHIPPING ? "Shipping (+$".concat(getFulfillmentDefaultRateAmount(order), ")") : undefined,
    isSelected: currentFulfillmentType === FULFILLMENT_TYPE_SHIPPING,
    onSelect: function onSelect(value) {
      return onChange({
        fulfillmentType: value
      });
    }
  }, currentOrderFulfillmentType === FULFILLMENT_TYPE_SHIPPING && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, "Get it in", ' ', getFulfillmentDefaultRateDuration(order, FULFILLMENT_TYPE_SHIPPING), " days"))), isFulfillmentTypeAvailable(order, FULFILLMENT_TYPE_DELIVERY) && /*#__PURE__*/React.createElement(FulfillmentTypePicker, {
    type: FULFILLMENT_TYPE_DELIVERY,
    isSelected: false,
    isAvailable: false,
    onSelect: function onSelect(value) {
      return onChange({
        fulfillmentType: value
      });
    }
  }, /*#__PURE__*/React.createElement("p", null, "Currently Unavailable")))));
}
FulfillmentInformationForm.defaultProps = defaultProps;
export default FulfillmentInformationForm;